import loadBackgrounds from "./loadBackgrounds.js";
import mobileMenuInit from "./mobileMenu.js";
import stepsSliderInit from "./stepsSlider.js";
import PopupCarousel from "./PopupCarousel.js";
import PopupCallback from "./PopupCallback.js";
import PopupLoader from "./PopupLoader.js";
import appointQuizInit from "./appointQuiz.js";
import specCardsInit from "./specCards.js";
import ReviewsCarousel from "./reviewsCarousel.js";

document.addEventListener("DOMContentLoaded", (e) => {
  loadBackgrounds();
  mobileMenuInit();
  stepsSliderInit();
  appointQuizInit();
  specCardsInit();

  /*--< ПОСЕТИТЕЛЬ ДОКРУТИЛ ДО КОНТАКТОВ >-------------------*/

  const contactsBlock = document.querySelector('#contacty');

  if (contactsBlock) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Если посетитель увидел блок контактов, значит он докрутил
          // до низа экрана и мы отправляем событие в Яндекс.Метрику.
          window.sendMetrikaEvent("scroll");

          observer.unobserve(contactsBlock);
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(contactsBlock);
  }

  /*--< REVIEWS CAROUSEL >-----------------------------------*/

  new ReviewsCarousel(document.querySelector(".why-reviews"));

  /*--< POPUP CAROUSEL >-------------------------------------*/

  document.querySelectorAll(".popup-carousel").forEach((element, key) => {
    window[`popupCarousel${key}`] = new PopupCarousel(element);
  });

  /*--< POPUP CALLBACK >-------------------------------------*/

  window.popupCallback = new PopupCallback(document.querySelector(".popup-callback"));

  /*--< POPUP LOADER >---------------------------------------*/

  window.popupLoader = new PopupLoader(document.querySelector(".popup-loader"));

  /*--< PHONE MASK >-----------------------------------------*/

  document.querySelectorAll(".phone-mask").forEach((input) => {
    window.IMask(input, {
      mask: "{+}0(000)000-00-00",
    });
  });

  /*--< HANDLE CTA FORMS >-----------------------------------*/

  document.querySelectorAll(".cta-form").forEach(form => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      let data = {
        name: ( formData.has("name") ? formData.get("name") : "" ),
        phone: formData.get("phone"),
        comment: ( formData.has("comment") ? formData.get("comment") : "" ),
      };

      window.popupLoader.show();

      fetch('/api/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          if (!response.ok) {
            window.popupLoader.hide();
            window.popupCallback.showError();
            return;
          }
          return response.json();
        })
        .then(result => {
          window.popupLoader.hide();
          window.popupCallback.showSuccess();
          window.sendMetrikaEvent("CALLBACK");
        })
        .catch(error => {
          window.popupLoader.hide();
          window.popupCallback.showError();
        });
    });
  });
});
